import { tasksRepo } from '@/constants/providers';
import { ProcessKey } from '@/modules/Processes/queries';
import { WorkflowKey } from '@/modules/Workflows/queries';
import { ApiResponse } from '@/shared/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { OrderTask } from '../types';
import { TaskKey } from './keys';

export const useOrderTask = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ApiResponse<unknown>, unknown, OrderTask>(
    (task) => tasksRepo.orderTask(task),
    {
      onError: () => {
        toast.error(t('error_order_task'));
      },
      onSettled: () => {
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(WorkflowKey.ALL);
        queryClient.invalidateQueries(ProcessKey.ALL);
      },
    },
  );
};
